import React from 'react';
import { Box, Typography } from '@mui/material';

import useLinkStyle from './styles';

const Link = ({ label, href, handleNav, disabled }) => {
    const linkStyle = useLinkStyle(disabled);

    return (
        <Box
            sx={{
                display: 'inline-block',
            }}
        >
            <Typography
                className="button-link"
                onClick={() => (!disabled ? handleNav(href) : null)}
                sx={linkStyle}
            >
                {label}
            </Typography>
        </Box>
    );
};

export default Link;
